import React from 'react';
import styled from 'styled-components';
import { typography, color } from 'styled-system';
const StyledSvg = styled('svg')(typography, color);

const CheckBadge = props => (
  <StyledSvg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M12 0c.988 0 1.827.635 2.132 1.519a2.257 2.257 0 013.932 1.494 2.257 2.257 0 012.855 3.085 2.256 2.256 0 011.725 3.834 2.254 2.254 0 01-.163 4.2 2.257 2.257 0 01-1.494 3.932 2.257 2.257 0 01-3.085 2.855 2.256 2.256 0 01-3.834 1.725 2.254 2.254 0 01-4.2-.163 2.257 2.257 0 01-3.932-1.494 2.257 2.257 0 01-2.855-3.085 2.256 2.256 0 01-1.725-3.834 2.254 2.254 0 01.163-4.2 2.257 2.257 0 011.494-3.932 2.257 2.257 0 013.085-2.855 2.256 2.256 0 013.834-1.725A2.254 2.254 0 0112 0zm2.833 8.656l-4.468 4.48-1.72-1.72a1.042 1.042 0 10-1.468 1.47l2.448 2.458a1.042 1.042 0 001.469 0l5.208-5.209a1.042 1.042 0 10-1.469-1.479z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </StyledSvg>
);
export default CheckBadge;
